import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import LinkWithRedirect from 'containers/LinkWithRedirect';
import { destroy } from 'redux-form';

import { openRequestEventReasonPopUpRequest } from 'containers/RequestEventRessonPopUp/action';
import { createEvent } from '../../containers/CreateEvent/action';
import { openCancelRequestEventPopUp } from 'containers/CancelRequestEventPopUp/actions';
import { setCommonPopup } from 'containers/Popup/actions';
import { studentResponseInvitaionRequest } from 'containers/InviteToEventModal/actions';
import ExportCSVButton from './ExportEventStudentsCSVButton';
import { getOfferEventDetailRequest } from 'containers/OfferEventRequestModal/actions';
import _ from 'lodash';
import _get from 'lodash/get';
import { studentResendEmail } from 'containers/StudentUpdateProfile/actions';
import { getVerifyPopupPayload } from 'utilities/handleValues';

class Banner extends Component {
  renderLockButton = () => {
    const { stateInfo, eventInfo } = this.props;
    if (eventInfo.joinedUsers && eventInfo.joinedUsers.length > 0) {
      return (
        <div className="book-btn" onClick={this.props.openPopupLockEvent}>
          {stateInfo.buttonText || stateInfo.statusText}
        </div>
      );
    }
    return (
      <div className="meshi-btn-cancel">
        {stateInfo.buttonText || stateInfo.statusText}
      </div>
    );
  };

  openPolicyPopup = () => {
    this.props.openAlertPopup();
  };

  inviteConfirmPopup = () => {
    const { eventInfo } = this.props;
    this.props.openConfirmPopup({
      title: 'イベントに参加しますか？',
      btnConfirm: 'はい',
      btnCancel: 'いいえ',
      closeButton: true,
      onConfirm: () => {
        this.props.studentResponseInvitaion({
          accepted: true,
          eventId: _.get(eventInfo, 'objectId', '')
        });
      },
      onHide: () => {
        this.props.studentResponseInvitaion({
          accepted: false,
          eventId: _.get(eventInfo, 'objectId', '')
        });
      }
    });
  };

  joinEvent = () => {
    const { showVerifyPopup, resendEmail, sendJoinRequest } = this.props;
    const currentUser = localStorage.getItem('account')
      ? JSON.parse(localStorage.getItem('account')).data
      : null;
    if (currentUser) {
      if (!currentUser.emailVerified) {
        resendEmail().then(() => {
          showVerifyPopup({
            ...getVerifyPopupPayload({ email: currentUser.email })
          });
        });
      } else {
        sendJoinRequest();
      }
    }
  };

  renderButton = () => {
    const { stateInfo, eventInfo } = this.props;
    const currentUser = localStorage.getItem('account')
      ? JSON.parse(localStorage.getItem('account')).data
      : null;

    if (_.get(eventInfo, 'offerEvent', false)) {
      if (!eventInfo.requestedUserIds.includes(_.get(currentUser, 'objectId')))
        return null;
      return (
        <div
          className="meshi-btn-locked text-normal"
          onClick={() => this.props.getOfferEventDetail({ eventId: eventInfo.objectId, reference: 'event_detail' })}
        >
          オファー承諾
        </div>
      );
    }

    if (!stateInfo) {
      return null;
    }

    if (stateInfo.eventPreview) {
      return (
        <Fragment>
          <div
            className="book-btn text-normal"
            onClick={() => this.props.createEvent(_.cloneDeep(eventInfo))}
          >
            募集開始
          </div>
          <Link to="/createEvent">
            <div className="event-detail-edit-btn">
              <img alt="" src="/images/edit.svg" />
              <span>編集</span>
            </div>
          </Link>
        </Fragment>
      );
    }
    if (currentUser && currentUser.role === 'STUDENT') {
      switch (stateInfo.status) {
        case 'WANTED_EXIT':
          return (
            <div className="wanted-exit text-normal">
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'EVENT_FINISHED':
          return (
            <div className="meshi-btn-event-fininshed text-normal">
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'INVITED':
          return (
            <div
              className="book-btn text-normal"
              onClick={this.inviteConfirmPopup}
            >
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'REQUESTED':
          return (
            <div
              className="meshi-btn-cancel text-normal"
              onClick={this.props.openCancelRequestEventPopUp}
            >
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'LOCKED':
          if (!currentUser.isAcceptPolicy) {
            return (
              <div
                onClick={this.openPolicyPopup}
                className="meshi-btn-locked text-normal"
              >
                {stateInfo.buttonText || stateInfo.statusText}
              </div>
            );
          }
          return (
            <Link
              to={{
                pathname: `/messages/${eventInfo.objectId}`,
                state: {
                  eventId: eventInfo.objectId
                }
              }}
            >
              <div className="meshi-btn-locked text-normal">
                {stateInfo.buttonText || stateInfo.statusText}
              </div>
            </Link>
          );
        // return <a href="https://line.me/R/ti/p/%40dsp2688o" rel="noopener noreferrer" target="_blank"><div className="meshi-btn-locked text-normal">LINEで連絡</div></a>;
        case 'WANTED':
          return (
            <div
              className="book-btn text-normal"
              onClick={this.joinEvent}
            >
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        default:
          return null;
      }
    } else if (
      currentUser &&
      currentUser.objectId === eventInfo.createdBy.objectId
    ) {
      switch (stateInfo.status) {
        case 'WANTED_EXIT':
          return (
            <div className="wanted-exit text-normal">
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'EVENT_FINISHED':
          return (
            <div className="meshi-btn-event-fininshed text-normal">
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'REQUESTED':
          return (
            <div
              className="meshi-btn-cancel text-normal"
              onClick={this.props.openCancelRequestEventPopUp}
            >
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        // case 'LOCKED':
        //   return (
        //     <div
        //       className="meshi-btn-locked text-normal"
        //       onClick={() =>
        //         this.props.history.push({
        //           pathname: `/messages/${eventInfo.objectId}`,
        //           state: {
        //             eventId: eventInfo.objectId
        //           }
        //         })
        //       }
        //     >
        //       {stateInfo.buttonText || stateInfo.statusText}
        //     </div>
        //   );
        // return <a href="https://line.me/R/ti/p/%40dsp2688o" rel="noopener noreferrer" target="_blank"><div className="meshi-btn-locked text-normal">LINEで連絡</div></a>;
        case 'WANTED':
          return this.renderLockButton();
        default:
          return null;
      }
    } else if (currentUser && currentUser.role === 'PRESIDENT') {
      switch (stateInfo.status) {
        case 'WANTED':
          return (
            <div className="pre-btn wanted">
              <img alt="" src="/images/pre-wanted-btn-icon.svg" />
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'LOCKED':
          return (
            <div className="pre-btn locked">
              <img alt="" src="/images/pre-locked-btn-icon.svg" />
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'EVENT_FINISHED':
          return (
            <div className="pre-btn finished">
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'EVENT_CANCELED':
          return (
            <div className="pre-btn finished">
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        default:
          return null;
      }
    } else if (!currentUser) {
      switch (stateInfo.status) {
        case 'WANTED_EXIT':
          return (
            <div className="wanted-exit text-normal">
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'EVENT_FINISHED':
          return (
            <div className="meshi-btn-event-fininshed text-normal">
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'REQUESTED':
          return (
            <div className="meshi-btn-cancel text-normal">
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'LOCKED':
          return (
            <div className="meshi-btn-locked text-normal">
              {stateInfo.buttonText || stateInfo.statusText}
            </div>
          );
        case 'WANTED':
          return (
            <LinkWithRedirect
              className="book-btn text-normal"
              storeSession={true}
              to="/loginStudent"
            >
              {stateInfo.buttonText || stateInfo.statusText}
            </LinkWithRedirect>
          );
        default:
          return null;
      }
    } else {
      return null;
    }
  };
  popupInactivePresident = (status) => {
    if (!status) {
      this.props.openPopupInactivePresident('この社長は掲載を終了しています');
    }
  };
  render() {
    const { collapse, eventInfo, stateInfo } = this.props;
    const currentUser = localStorage.getItem('account')
      ? JSON.parse(localStorage.getItem('account')).data
      : null;
    const presidentId = eventInfo.createdBy && eventInfo.createdBy.objectId;

    let presidents = '';
    if (eventInfo && eventInfo.createdBy) {
      presidents = eventInfo.createdBy;
    }
    let avatar = '';
    if (presidents && presidents.avatarImage) {
      avatar = presidents.avatarImage;
    }
    let company = '';
    if (presidents && presidents.presidentProfile) {
      company = presidents.presidentProfile.companyName;
    }
    let isActive = true;
    if (presidents && presidents.status) {
      if (presidents.status === 'ACTIVE') {
        isActive = true;
      }
      if (presidents.status === 'INACTIVE') {
        isActive = false;
      }
    }
    return (
      <Fragment>
        <div className={'fixed-header-content'}>
          <div className={'header-col-details'}>
            <Fragment>
              <div
                className={`header-name-label text-bold collapse-${collapse}`}
                style={collapse ? { marginTop: '16px' } : {}}
              >
                {eventInfo.name}
              </div>

              <div className={`collapse-${collapse} event-president-details `}>
                <Link
                  onClick={() => {
                    this.popupInactivePresident(isActive);
                  }}
                  to={
                    isActive ? '/presidentDetail/' + presidents.objectId : '#'
                  }
                >
                  <img
                    className="event-president-avatar"
                    src={
                      avatar ? avatar.thumbSmall : 'images/default-profile.png'
                    }
                    alt="社長メシ"
                  />
                  <div className="event-president-name">
                    <div className="president-name-details text-bold">
                      {presidents && presidents.displayName}
                    </div>
                    <div className="president-company-details text-normal">
                      {company}
                    </div>
                  </div>
                </Link>
              </div>

              {(!currentUser || currentUser.objectId !== presidents.objectId) &&
                isActive && (
                <Link
                  to={{
                    pathname: `/event-list/${presidentId}`,
                    state: eventInfo.objectId
                  }}
                  className={`president-elist-nav text-normal collapse-${collapse}`}
                >
                  <div>
                    {(presidents && presidents.displayName) +
                        ' 社長の社長メシを全て見る'}
                  </div>
                  <img
                    src="/images/orange.svg"
                    alt="arrow"
                    className="arrow-nav"
                  />
                </Link>
              )}
            </Fragment>
          </div>

          <div className={'header-col-btn'}>
            {/* Render 2 extra buttons if not offer event, not event preview and created by same president id */}
            {this.renderButton()}
            {!_get(stateInfo, 'eventPreview') &&
              _get(currentUser, 'objectId', '') === presidentId &&
              !_get(eventInfo, 'offerEvent', false) && (
              <>
                {_get(eventInfo, 'joinedQuantity') !== '0' && (
                  <div
                    className="meshi-btn-locked text-normal"
                    onClick={() => {
                      this.props.history.push({
                        pathname: `/messages/${eventInfo.objectId}`,
                        state: {
                          eventId: eventInfo.objectId
                        }
                      });
                    }}
                  >
                      チャットをはじめる
                  </div>
                )}
                <Link
                  to={`/editEvent/${eventInfo.objectId}`}
                  onClick={() => {
                    this.props.destroyForm('createEvent');
                  }}
                >
                  <div className="event-detail-edit-btn">
                    <img alt="" src="/images/edit.svg" />
                    <span>編集</span>
                  </div>
                </Link>
                <ExportCSVButton
                  eventId={eventInfo.objectId}
                  fileName={`${eventInfo.name}.csv`}
                />
              </>
            )}
            {/* <div className={`bookmark-count ${!currentUser && 'hidden-content'}`}>
              <img src="/images/bookmark.svg" alt="bookmark" />
              <div className="bookmark-number"> {eventInfo && eventInfo.requestedQuantity + ' picks'} </div>
            </div> */}
            {/* {_get(currentUser, 'objectId', '') === presidentId && (
              <ExportCSVButton
                eventId={eventInfo.objectId}
                fileName={`${eventInfo.name}.csv`}
              />
            )} */}
          </div>
        </div>
      </Fragment>
    );
  }
}

Banner.propTypes = {
  history: PropTypes.any,
  stateInfo: PropTypes.object,
  collapse: PropTypes.bool,
  eventInfo: PropTypes.object,
  createEvent: PropTypes.func,
  openPopupLockEvent: PropTypes.func,
  openCancelRequestEventPopUp: PropTypes.func,
  sendJoinRequest: PropTypes.func,
  openPopupInactivePresident: PropTypes.func,
  openAlertPopup: PropTypes.func,
  closeAlertPopup: PropTypes.func,
  openConfirmPopup: PropTypes.func,
  studentResponseInvitaion: PropTypes.func,
  getOfferEventDetail: PropTypes.func,
  destroyForm: PropTypes.func,
  showVerifyPopup: PropTypes.func,
  resendEmail: PropTypes.func
};

const mapDispatchToProps = (dispatch) => ({
  getOfferEventDetail: ({ eventId, reference }) =>
    dispatch(getOfferEventDetailRequest({ eventId, reference })),
  sendJoinRequest: () => dispatch(openRequestEventReasonPopUpRequest()),
  openCancelRequestEventPopUp: () => dispatch(openCancelRequestEventPopUp()),
  createEvent: (eventInfo) => dispatch(createEvent({ eventInfo })),
  openPopupLockEvent: () => dispatch(setCommonPopup('lockEvent', true)),
  openPopupInactivePresident: (message) =>
    dispatch(setCommonPopup('success', { message })),
  openAlertPopup: () => dispatch(setCommonPopup('policy', true)),
  closeAlertPopup: () => dispatch(setCommonPopup('policy', false)),
  openConfirmPopup: (show) => dispatch(setCommonPopup('confirm', show)),
  studentResponseInvitaion: ({ accepted, eventId }) =>
    dispatch(studentResponseInvitaionRequest({ accepted, eventId })),
  destroyForm: (name) => dispatch(destroy(name)),
  showVerifyPopup: (payload) => dispatch(setCommonPopup('confirm', payload)),
  resendEmail: (payload) => dispatch(studentResendEmail(payload))
});

export default connect(null, mapDispatchToProps)(withRouter(Banner));
